import styled from 'styled-components';

export const StyledGeneralAlertsContainer = styled.div`
  .GeneralAlertsContainer__Main {
    padding: 10px 19px 0 19px;
  }
`;
